module.exports = __webpack_public_path__ + "static/media/user.e0160c8a.svg";